import { render } from "./FullDayView.vue?vue&type=template&id=5a5b8801"
import script from "./FullDayView.vue?vue&type=script&lang=js"
export * from "./FullDayView.vue?vue&type=script&lang=js"

import "./FullDayView.vue?vue&type=style&index=0&id=5a5b8801&lang=css"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__